import React, { useEffect, useState, useContext } from "react";
import { useNavigate,useLocation } from "react-router-dom";

import Heading from "../../../Components/Heading/Heading";
import { APICall } from "../../../Helpers/API/APICalls";
import { getContext ,LoaderContext} from "../../../Helpers/Context/Context";
import notify from "../../../Helpers/ToastNotification";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import {
  GetDropDownList,
  getStreamOptions,
  getEnquiryEngagementNames,
  getEnquiryCreateEngagement,
  getEditScrennData,
  GetStream,
} from "../../../Helpers/API/APIEndPoints";
import SelectForm from "../../../Components/SelectForm/SelectForm";

import InputForm from "../../../Components/InputForm/InputForm";

const Enquiry = () => {
  {
    /* By Krishnam 16-052024 */
  }
  let navigate = useNavigate();

  //getting the passed id from the locations
  const { state } = useLocation();
  const [engagementName, setEngagementName] = useState("");
  const [streamsOptions, setStreamOptions] = useState<any>([]);
  const [streamValue, setStream] = useState<any>([]);
  const [exist,setExist] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [loader, setLoader] = useState(true);

  
  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [customerSelectedData, setCustomer] = useState([]);

  const [reset, setReset] = React.useState<any>(false);

  //For IsActive
  const [isActive, setIsActive] = useState(true);

  //For Storing  privious EngagementNames
  const [priviousengagementNames, setEngagementNames] = useState([]);

  //Getting the RoleId and EmployeeId from the Context and Loader as well
  const { RoleId, EmployeeId } = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);



  

  useEffect(() => {
    onLoadApi();
  }, []);




  //Loading all the required data for the initial redering
  const onLoadApi = async () => {
    await customerApiCall();
    await streamApiCall();
    await engagementNamesApiCall();
    await getApplicationById();
    setLoader(false);
  };


  //Calling the customer api for customer dropdown
  const customerApiCall = async () => {
    let postObject = {
      searchFor: "customer",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let customerArray = [];
      await data.map((customer: any) => {
        let tempObj = {
          abb: customer.abbreviation,
          value: customer.id,
          label: customer.name,
        };
        customerArray.push(tempObj);
      });
      setCustomerOptions(customerArray);
    }
  };

  //Here this method calls stream Api
  const streamApiCall = async () => {
    const { data } = await APICall(GetStream, "GET");
    //console.log("stream data", data);

    if (data != undefined || data != null) {
      let streamArray = [];
      await data.map((stream: any) => {
        let tempObj = {
          value: stream.value,
          label: stream.label,
        };
        streamArray.push(tempObj);
      });
      setStreamOptions(streamArray);
    }
  };

  //for storing previous  Engagement Names for checking the already Exist name
  const engagementNamesApiCall = async () => {
    let postObject = {};
    const { data } = await APICall(
      getEnquiryEngagementNames,
      "POST",
      postObject
    );
    // console.log("EngagementNames", data);
    if (data != undefined || data != null) {
      setEngagementNames([...data]);
    }
  };

  //function to get GridData;
 
 

  const ResetFunction = () => {
    setCustomer([]);
  };

  //sangam
  const SelectOnChange = (event, apiField) => {
    if (apiField == "customer") {
      setCustomer([event]);
      setFormErrors({...formErrors,customer:""});
    }
    if (apiField === "stream") {
      setStream([event]);
      setFormErrors({...formErrors,stream:""});
    }
  };

  const handleOnSubmit =  async () => {

    //Handling Validations
     
    if ((!customerSelectedData || customerSelectedData.length==0) && (!streamValue || streamValue.length==0) && (!engagementName || engagementName.trim().length ==0)) {
      setFormErrors({...formErrors,stream:"Please Select a Stream",customer:"Please Select a Customer",EngagementName:"Please Enter the Engagement Name"});
      return 
      
    }
    else if((!customerSelectedData || customerSelectedData.length==0) && (!streamValue || streamValue.length==0)){
      setFormErrors({...formErrors,stream:"Please Select a Stream",customer:"Please Select a Customer"});
      return

    } else if(!streamValue || streamValue.length ==0)
    {
      setFormErrors({...formErrors,stream:"Please Select a Stream"});
    }else if(!customerSelectedData || customerSelectedData.length ==0){
      setFormErrors({...formErrors,customer:"Please Select a Customer"});
      return

    }
    else if(!engagementName || engagementName.trim().length ==0){
      setFormErrors({...formErrors,EngagementName:"Please Enter a Engagement Name"});
      return 

    }else if(exist){
      setFormErrors({...formErrors,EngagementName:"Please Enter a different Engagement Name"});
      return
    }




    let customerId = customerSelectedData[0].value;
    let streamId = streamValue[0].value;

    let postObject = {
      CustomerId: customerId,
      StreamId: streamId,
      FunctionalOwner: parseInt(EmployeeId),
      EngagementName:engagementName,
      IsActive:isActive,
      EngagementId:state
      
    };

    //console.log('UpdateObj',postObject);
   const { data } = await APICall(getEnquiryCreateEngagement, "POST", postObject);

   if(data){
    if(state){

      notify(0,"Enquiry has been Updated");
    }
    else{

      notify(0,"Enquiry has been Created");
    }
     navigate(-1);
        
    
     


   }

   //

  };

  //Handling Engagementname Input
  const handleEngagementNameChange = (e: any) => {
    let alreadyNamed = priviousengagementNames.find(
      (obj: any) =>
        obj.engagementName.toLowerCase() == e.target.value.toLowerCase()
    );
    if (!alreadyNamed) {
      setEngagementName(e.target.value);
      setFormErrors({ ...formErrors, EngagementName: "" });
      setExist(false);
    } else {
      setEngagementName(e.target.value);
      setExist(true);
      setFormErrors({ ...formErrors, EngagementName: "Already Exist" });
    }
  };

//Getting the Customer Id
const getApplicationById = async () => {
    if (state !== null) {
      let post = {
        EngagementId: state,
      };

      const { data } = await APICall(getEditScrennData, "POST", post);
    
      setCustomer([{
        value: data.customerId,
        label: data.customer,
      }]);
      setStream([{
        value: data.streamId,
        label: data.stream,
      }])
      setEngagementName(data.engagementName)
      setIsActive(data.isActive);
        
      }
    }

    //handling the reset button
     const handleOnReset =()=>{
     
      setEngagementName('');
      setIsActive(false);
      setCustomer([]);
      setStream([]);
     }
 
 

  return (
    <>
      <Heading title={"Enquiry"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Select Customer <sup>*</sup>
              </label>
              <SelectForm
                value={customerSelectedData}
                onChange={(e) => SelectOnChange(e, "customer")}
                options={customerOptions}
                isDisabled={false}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
                placeholder="Select"
              />
              <p style={{ color: "red" }}>{formErrors["customer"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement Name <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={engagementName}
                onChange={handleEngagementNameChange}
              />
              <p style={{ color: "red" }}>{formErrors["EngagementName"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 ">
            <div className="form-group">
              <label>
                Stream <sup>*</sup>
              </label>
              <SelectForm
                value={streamValue}
                options={streamsOptions}
                onChange={(event) => SelectOnChange(event, "stream")}
                isDisabled={false}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
                placeholder="Select"
              />
              <p style={{ color: "red" }}>{formErrors["stream"]}</p>
            </div>
          </div>

          {state && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="isActive">Is Active</label>
                <div>
                  <input
                    type="checkbox"
                    id="isActive"
                    onChange={(e) => setIsActive(e.target.checked)}
                    name="isActive"
                    checked={isActive}
                    className="m-1"
                  />
                </div>
              </div>
            </div>
          )}

          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button onClick={() => navigate(-1)} className="btn btn-reset">
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button onClick={handleOnReset} className="btn btn-reset">
                  Reset
                </button>
                <button onClick={handleOnSubmit} className="btn btn-submit">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Enquiry;